import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from "react";
import { RedirectUrlValue } from "../context/RedirectUrlValue.js";
import axios from "axios";
import { ReactComponent as Gmclassic } from "../assets/svg/logo/GmClassic.svg";
import { useNavigate } from "react-router-dom";
import "../styles/Home.css";

export default function Scanpage() {
    const { toggleredirectUrl } = useContext(RedirectUrlValue);
    const [isScan, setIsScan] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const headers = useMemo(
        () => ({
            "Content-Type": "application/json",
            apiKey: process.env.REACT_APP_API_SECRET_HASH,
        }),
        [],
    );

    // ✅ FIX 1 : parsing robuste, résistant aux trailing slash et params réseau
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    const client = pathParts[1]?.toLowerCase() || "";

    const updateData = useCallback(async () => {
        try {
            await axios.put(
                `${process.env.REACT_APP_API_BASE_URL}/api/clientinfo/${client}/increment`,
                {},
                { headers },
            );
        } catch (error) {
            throw new Error("Erreur lors de la mise à jour des données");
        }
    }, [client, headers]);

    const handleScan = useCallback(
        (scanData) => {
            const qrResult = scanData.toLowerCase();
            if (
                qrResult.includes("greenme.info") ||
                qrResult.includes("goserveurtest.fr") ||
                qrResult.includes("localhost")
            ) {
                // ✅ FIX 1 : URL API robuste au lieu de split manuel
                const parsedUrl = new URL(scanData);
                const parts = parsedUrl.pathname.split("/").filter(Boolean);
                const detectedClient = parts[1]?.toLowerCase() || "";

                toggleredirectUrl(detectedClient);
                localStorage.setItem("selectedLanguage", "");
                setIsScan(true);
            }
        },
        [toggleredirectUrl],
    );

    useEffect(() => {
        const fetchData = async () => {
            try {
                await updateData();
            } catch (error) {
                console.error(error.message);
                try {
                    await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}/api/errors`,
                        {
                            error: error.message,
                            client,
                            time: new Date().toISOString(),
                        },
                        { headers },
                    );
                } catch (loggingError) {
                    console.error(
                        "Erreur lors de l'enregistrement de l'erreur",
                        loggingError,
                    );
                }
            } finally {
                // ✅ FIX 3 : un seul appel à handleScan quoi qu'il arrive
                handleScan(window.location.href);
                setIsLoading(false);
            }
        };

        fetchData();
    }, [client, headers, handleScan, updateData]);

    useEffect(() => {
        if (isScan) {
            window.location.href = "/mainpage";
        }
    }, [isScan, navigate]);

    return (
        <div className="load">
            {isLoading && (
                <Gmclassic
                    className="Gmclassic"
                    fill="#1B9A68"
                    aria-label="Flèche retour"
                />
            )}
        </div>
    );
}
